export default __webpack_public_path__ + "static/media/RestaurantLandingPage.2bead12e.jpeg";